import { Stack as NbStack } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Stack = NbStack;

export default addWithConfig(Stack);
